// extracted by mini-css-extract-plugin
export default {"p":"Footer_p__iHp7l","rigthFooter":"Footer_rigthFooter__a9g9X","socialPages":"Footer_socialPages__iKePm","footer_nav":"Footer_footer_nav__D-PGX"};